<script>
export default {
  name: 'BaseLink',
  props: {
    href: {
      type: String,
      default: '/',
    },
  },
};
</script>

<template>
  <a :href="href" class="base-link">
    <slot />
  </a>
</template>
